"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Link = _interopRequireDefault(require("../Link"));

var _NotificationBannerInline = _interopRequireDefault(require("../NotificationBannerInline"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constant = require("./constant");

var _BookingConfirmation = _interopRequireDefault(require("./BookingConfirmation.proptypes"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "BookingConfirmation__StyledContainer",
  componentId: "sc-hg5l6h-0"
})(["display:flex;flex-direction:column;padding:", ";background:", ";box-shadow:", ";", ""], function (_ref) {
  var theme = _ref.theme,
      isMobile = _ref.isMobile;
  return isMobile ? theme.space.small : theme.space.standard;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor.default;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.space.none, " 1px  ").concat(theme.space.micro, " rgba(0, 0, 0, 0.16)");
}, function (_ref4) {
  var isMobile = _ref4.isMobile,
      theme = _ref4.theme;
  return !isMobile && "border-radius: ".concat(theme.borderRadius.normal, ";");
});

var StyledTopContent = _styledComponents.default.div.withConfig({
  displayName: "BookingConfirmation__StyledTopContent",
  componentId: "sc-hg5l6h-1"
})(["display:flex;align-items:center;justify-content:center;flex-direction:column;"]);

var StyledSubTitle = _styledComponents.default.div.withConfig({
  displayName: "BookingConfirmation__StyledSubTitle",
  componentId: "sc-hg5l6h-2"
})(["max-width:375px;"]);

var StyledBottomContent = _styledComponents.default.div.withConfig({
  displayName: "BookingConfirmation__StyledBottomContent",
  componentId: "sc-hg5l6h-3"
})(["display:flex;flex-direction:column;padding:", " 0;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.standard;
});

var StyledDivider = _styledComponents.default.hr.withConfig({
  displayName: "BookingConfirmation__StyledDivider",
  componentId: "sc-hg5l6h-4"
})(["border:none;border-bottom:1px solid ", ";width:100%;margin:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.backgroundColor.greyLine;
}, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.space.standard, " ").concat(theme.space.none);
});

var StyledCustomText = _styledComponents.default.span.withConfig({
  displayName: "BookingConfirmation__StyledCustomText",
  componentId: "sc-hg5l6h-5"
})(["span{font-weight:", ";}"], function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.fontWeight.large);
});

var StyledTextWrapper = _styledComponents.default.div.withConfig({
  displayName: "BookingConfirmation__StyledTextWrapper",
  componentId: "sc-hg5l6h-6"
})(["& > div{justify-content:center;}"]);

var getKey = function getKey() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return key + Math.random();
};

var BookingConfirmation = function BookingConfirmation(_ref9) {
  var accessible = _ref9.accessible,
      customProperties = _ref9.customProperties,
      theme = _ref9.theme,
      translation = _ref9.translation,
      state = _ref9.state,
      data = _ref9.data,
      hasNotificationBanner = _ref9.hasNotificationBanner,
      notificationBannerType = _ref9.notificationBannerType,
      isMobile = _ref9.isMobile,
      customIcon = _ref9.customIcon,
      iconAlt = _ref9.iconAlt,
      enableLinkTransformation = _ref9.enableLinkTransformation;

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  var sanitizeStr = function sanitizeStr(str) {
    return str.replace(/[{}.]/g, '');
  };

  var renderCustomText = function renderCustomText(txt, key) {
    // customized text to insert component/tag
    if (Object.keys(_constant.TEMPLATE_STR).includes(sanitizeStr(txt)) && txt.match(/[{}]/g)) {
      var templateKey = sanitizeStr(txt);
      var displayText = "".concat(txt.replace(_constant.TEMPLATE_STR[templateKey], data[templateKey]));

      if (enableLinkTransformation) {
        var isValidEmail = _utilities.default.validateEmail(displayText);

        var isValidURL = _utilities.default.validateURL(displayText);

        if (isValidEmail || isValidURL) {
          return /*#__PURE__*/_react.default.createElement(StyledCustomText, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
            href: isValidEmail ? "mailto:".concat(displayText) : displayText
          }, displayText), "\xA0");
        }
      }

      return /*#__PURE__*/_react.default.createElement(StyledCustomText, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
        key: getKey(key),
        tag: _constant.TEXT.span,
        accessible: accessible,
        display: _constant.TEXT.inlineFlex,
        hasToggle: false,
        theme: theme,
        type: _constant.TEXT.default,
        bold: true
      }, displayText, "\xA0"));
    }

    return "".concat(txt, " ");
  };

  var renderContentMsg = function renderContentMsg(txt) {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      key: getKey(),
      tag: _constant.TEXT.div,
      accessible: accessible,
      display: _constant.TEXT.block,
      textAlign: _constant.TEXT.center,
      hasToggle: false,
      theme: theme,
      type: _constant.TEXT.default,
      marginBottom: isMobile ? _constant.TEXT.small : _constant.TEXT.micro
    }, txt);
  };

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, (0, _extends2.default)({
    isMobile: isMobile
  }, customProperties, {
    tabIndex: !accessible ? '-1' : '0'
  }), /*#__PURE__*/_react.default.createElement(StyledTopContent, null, customIcon !== '' ? /*#__PURE__*/_react.default.createElement("img", {
    src: customIcon,
    alt: iconAlt
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant.STATE_ICON_COLOR[state],
    fontsize: _constant.TEXT.titleXXLarge,
    icon: _constant.STATE_ICON[state],
    theme: theme
  }), /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant.TEXT.inlineFlex,
    hasToggle: false,
    theme: theme,
    type: _constant.TEXT.titleSmall,
    textAlign: _constant.TEXT.center
  }, language.title), /*#__PURE__*/_react.default.createElement(StyledSubTitle, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant.TEXT.inlineFlex,
    hasToggle: false,
    theme: theme,
    type: _constant.TEXT.sub,
    textAlign: _constant.TEXT.center,
    color: _constant.TEXT.greyDarker
  }, language.subTitle.replace(_constant.TEMPLATE_STR.name, data.name))), /*#__PURE__*/_react.default.createElement(StyledDivider, null), /*#__PURE__*/_react.default.createElement(StyledTextWrapper, {
    isMobile: isMobile
  }, language.contentMsg1 && renderContentMsg(language.contentMsg1.split(' ').map(function (txt, key) {
    return renderCustomText(txt, key);
  })), language.contentMsg2 && renderContentMsg(language.contentMsg2.split(' ').map(function (txt, key) {
    return renderCustomText(txt, key);
  })), language.contentMsg3 && renderContentMsg(language.contentMsg3.split(' ').map(function (txt, key) {
    return renderCustomText(txt, key);
  })))), hasNotificationBanner && /*#__PURE__*/_react.default.createElement(StyledBottomContent, null, /*#__PURE__*/_react.default.createElement(_NotificationBannerInline.default, {
    accessible: accessible,
    border: true,
    closable: false,
    fullWidth: true,
    message: language.notificationMsg,
    showLeftIcon: true,
    textType: _constant.TEXT.small,
    theme: theme,
    type: notificationBannerType
  }))));
};

BookingConfirmation.propTypes = _BookingConfirmation.default.PropTypes;
BookingConfirmation.defaultProps = _BookingConfirmation.default.DefaultProps;
var _default = BookingConfirmation;
exports.default = _default;